
import Vue from 'vue'
import Component from "vue-class-component";
import OrderListCommon from "@/components/order/order/OrderListCommon.vue";
import OrderSectionTabs from "@/components/order/order/OrderSectionTabs.vue";

@Component({
  name: 'OrderList',
  components: {
    OrderListCommon,
    OrderSectionTabs,
  }
})
export default class OrderList extends Vue {

  protected get subscriptionId(): number | null {
    const rawValue = this.$route.query.subscriptionId;
    const parsed = parseInt(Array.isArray(rawValue) ? (rawValue[0] || '') : (rawValue || ''), 10);
    return Number.isNaN(parsed) ? null : parsed;
  }

}

